<template>
  <section class="main-box">
    <div>
      <ProjectList @proSelected="proChange"></ProjectList>
    </div>
    <div class="envbox">
      <div class="title"><i></i>环境监测</div>
      <ul class="tabEnvBox">
        <li>
          <el-col :span="8"><img src="../../assets/img/ic_wendu.png"></el-col>
          <el-col :span="12" style="padding:12px;">
            <div>温度</div>
            <div style="font-size: 12px;color:#9d9d9d">{{this.envMonitorData.temp}}℃</div>
          </el-col>
        </li>
        <li>
          <el-col :span="8"><img src="../../assets/img/ic_shidu.png"></el-col>
          <el-col :span="12" style="padding:12px;">
            <div>湿度</div>
            <div style="font-size: 12px;color:#9d9d9d">{{this.envMonitorData.humi}}%</div>
          </el-col>
        </li>
        <li>
          <el-col :span="8"><img src="../../assets/img/ic_fengli.png"></el-col>
          <el-col :span="12" style="padding:12px;">
            <div>风力/风向</div>
            <div style="font-size: 12px;color:#9d9d9d">
              {{this.envMonitorData.windPower}}/{{this.envMonitorData.windDir}}
            </div>
          </el-col>
        </li>
      </ul>
      <el-row>
        <el-col :span="12">
          <div id="pm" style="width: 100%;height: 260px;"></div>
        </el-col>
        <el-col :span="12">
          <div id="zy" style="width: 100%;height: 260px;"></div>
          <!--
            <el-col :span="8">
                <div class="mesbox">
                    <ul class="meslist">
                        <li><i class="el-icon-caret-top mesredcolor"></i><span class="mesredcolor">17%</span></li>
                        <li>46ug/m3</li>
                        <li>用电前周同比</li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="mesbox">
                    <ul class="meslist">
                        <li><i class="el-icon-caret-top mesredcolor"></i><span class="mesredcolor">18%</span></li>
                        <li>46db</li>
                        <li>噪音前周同比</li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="mesbox">
                    <ul class="meslist">
                        <li><i class="el-icon-caret-bottom mesgreencolor"></i><span class="mesgreencolor">17%</span></li>
                        <li>4625</li>
                        <li>总用电前周同比</li>
                    </ul>
                </div>
            </el-col>-->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="mesbox">
            <ul class="meslist">
              <li v-if="this.envMonitorData.pm2d5Cmp>0">
                <i class="el-icon-caret-top mesredcolor"></i>
                <span class="mesredcolor">{{this.envMonitorData.pm2d5Cmp}}%</span>
              </li>
              <li v-if="this.envMonitorData.pm2d5Cmp<0">
                <i class="el-icon-caret-bottom mesgreencolor"></i>
                <span class="mesgreencolor">{{this.envMonitorData.pm2d5Cmp}}%</span>
              </li>
              <li>{{this.envMonitorData.pm2d5Rt}}ug/m3</li>
              <li>PM2.5前周同比</li>
            </ul>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="mesbox">
            <ul class="meslist">
              <li v-if="this.envMonitorData.pm10Cmp>0">
                <i class="el-icon-caret-top mesredcolor"></i>
                <span class="mesredcolor">{{this.envMonitorData.pm10Cmp}}%</span>
              </li>
              <li v-if="this.envMonitorData.pm10Cmp<0">
                <i class="el-icon-caret-bottom mesgreencolor"></i>
                <span class="mesgreencolor">{{this.envMonitorData.pm10Cmp}}%</span>
              </li>
              <li>{{this.envMonitorData.pm10Rt}}</li>
              <li>PM10前周同比</li>
            </ul>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="mesbox">
            <ul class="meslist">
              <li v-if="this.envMonitorData.noiseCmp>0">
                <i class="el-icon-caret-top mesredcolor"></i>
                <span class="mesredcolor">{{this.envMonitorData.noiseCmp}}%</span>
              </li>
              <li v-if="this.envMonitorData.noiseCmp<0">
                <i class="el-icon-caret-bottom mesgreencolor"></i>
                <span class="mesgreencolor">{{this.envMonitorData.noiseCmp}}%</span>
              </li>
              <li>{{this.envMonitorData.noiseRt}}db</li>
              <li>噪音前周同比</li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row style="padding: 30px;">
        <el-col :span="8" class="tabcheck">
          <el-col :span="12" style="padding: 10px;">
            <div class="tabchecktext">雾炮</div>
          </el-col>
          <el-col :span="12" style="text-align: right;padding: 10px;">
            <el-switch v-model="value1" @change="option3">
            </el-switch>
          </el-col>
        </el-col>
        <el-col :span="8" class="tabcheck">
          <el-col :span="12" style="padding: 10px;">
            <div class="tabchecktext">塔吊喷淋</div>
          </el-col>
          <el-col :span="12" style="text-align: right;padding: 10px;">
            <el-switch v-model="value7" @change="option4">
            </el-switch>
          </el-col>
        </el-col>
        <el-col :span="8" class="tabcheck">
          <el-col :span="12" style="padding: 10px;">
            <div class="tabchecktext">围墙喷淋</div>
          </el-col>
          <el-col :span="12" style="text-align: right;padding: 10px;">
            <el-switch v-model="value3" @change="option5">
            </el-switch>
          </el-col>
        </el-col>
        <el-col :span="8" class="tabcheck">
          <el-col :span="12" style="padding: 10px;">
            <div class="tabchecktext">道路喷淋</div>
          </el-col>
          <el-col :span="12" style="text-align: right;padding: 10px;">
            <el-switch v-model="value4" @change="option6">
            </el-switch>
          </el-col>
        </el-col>
        <el-col :span="8" class="tabcheck">
          <el-col :span="12" style="padding: 10px;">
            <div class="tabchecktext">镝灯</div>
          </el-col>
          <el-col :span="12" style="text-align: right;padding: 10px;">
            <el-switch v-model="value5" @change="option7">
            </el-switch>
          </el-col>
        </el-col>
        <el-col :span="8" class="tabcheck">
          <el-col :span="12" style="padding: 10px;">
            <div class="tabchecktext">太阳能路灯</div>
          </el-col>
          <el-col :span="12" style="text-align: right;padding: 10px;">
            <el-switch v-model="value6" @change="option8">
            </el-switch>
          </el-col>
        </el-col>

      </el-row>
    </div>
    <el-col :span="12">
      <div class="elebox">
        <div class="title"><i></i>节电管理</div>
        <div class="charbox">
          <div id="electric" style="width: 100%;height: 260px;"></div>
          <div class="eletitle centerlay">上月用电平均值<span>{{this.eleData.workArea.lastAverVal}}</span>度
            <i class="el-icon-caret-bottom mesgreencolor" v-if="this.eleData.workArea.lastAverVal<0"></i>
            <i class="el-icon-caret-top mesredcolor" v-if="this.eleData.workArea.lastAverVal>0"></i>
            <span>{{this.eleData.workArea.lastAverCmp}}</span>%
          </div>
        </div>
        <div style="margin-top: 20px;">
          <div style="font-size: 18px;font-weight: bold;color: #383e45">寝室用电数据</div>
          <div class="eletitle">
            <div style="float: left">
              上月用电平均值<span>{{this.eleData.liveArea.lastAverVal}}</span>度
              <i class="el-icon-caret-bottom mesgreencolor" v-if="this.eleData.liveArea.lastCmp<0"></i>
              <i class="el-icon-caret-top mesredcolor" v-if="this.eleData.liveArea.lastCmp>0"></i>
              <span>{{this.eleData.liveArea.lastCmp}}</span>%
            </div>
            <div style="background: #FFFFFF;float: right">
              <div class="rcircle layout-left margin-right"></div>
              <div class="layout-left margin-right">亮灯</div>
              <div class="circle layout-left margin-right"></div>
              <div class="layout-left margin-right">灭灯</div>
              <div class="recircle layout-left margin-right"></div>
              <div class="layout-left margin-right">远程灭灯</div>
            </div>
            <div style="clear: both"></div>
          </div>
          <div style="overflow-y: scroll; height: 187px;">
            <table cellspacing="1" v-for="(item,index) in this.eleData.liveArea.buildings">
              <tr class="trbg">
                <td>{{index+1}}-101</td>
                <td>{{index+1}}-102</td>
                <td>{{index+1}}-103</td>
                <td>{{index+1}}-104</td>
                <td>{{index+1}}-105</td>
                <td>{{index+1}}-106</td>
                <td>{{index+1}}-107</td>
                <td>{{index+1}}-108</td>
              </tr>
              <tr class="tdbg">
                <td v-for="n of 8 ">
                  <div v-if="item[index+1+'-10'+n]==1" class="rcircle"></div>
                  <div v-if="item[index+1+'-10'+n]==0" class="circle"></div>
                  <div v-if="item[index+1+'-10'+n]==2" class="recircle"></div>
                </td>
              </tr>
              <tr class="trbg">
                <td>{{index+1}}-201</td>
                <td>{{index+1}}-202</td>
                <td>{{index+1}}-203</td>
                <td>{{index+1}}-204</td>
                <td>{{index+1}}-205</td>
                <td>{{index+1}}-206</td>
                <td>{{index+1}}-207</td>
                <td>{{index+1}}-208</td>
              </tr>
              <tr class="tdbg">
                <td v-for="n of 8 ">
                  <div v-if="item[index+1+'-20'+n]==1" class="rcircle"></div>
                  <div v-if="item[index+1+'-20'+n]==0" class="circle"></div>
                  <div v-if="item[index+1+'-20'+n]==2" class="recircle"></div>
                </td>
              </tr>
            </table>

          </div>
        </div>
      </div>
    </el-col>
    <el-col :span="12">
      <div class="elebox layout-right">
        <div class="title"><i></i>节水管理</div>
        <div class="charbox">
          <div id="warter" style="width: 100%;height: 260px;"></div>
          <div class="eletitle centerlay">上月用电平均值<span>{{this.waterData.workArea.lastAverVal}}</span>ml
            <i class="el-icon-caret-bottom mesgreencolor" v-if="this.waterData.workArea.lastAverCmp<0"></i>
            <i class="el-icon-caret-top mesredcolor" v-if="this.waterData.workArea.lastAverCmp>0"></i>
            <span>{{this.waterData.workArea.lastAverCmp}}</span>%
          </div>
        </div>
        <div class="charbox">
          <div id="life" style="width: 100%;height: 270px; margin-top: 20px;"></div>
          <div class="eletitle centerlay">上月用电平均值<span>{{this.waterData.liveArea.lastAverVal}}</span>ml
            <i class="el-icon-caret-bottom mesgreencolor" v-if="this.waterData.liveArea.lastCmp<0"></i>
            <i class="el-icon-caret-top mesredcolor" v-if="this.waterData.liveArea.lastCmp>0"></i>
            <span>{{this.waterData.liveArea.lastCmp}}</span>%
          </div>
        </div>
      </div>
    </el-col>
  </section>
</template>

<script>
  import echarts from 'echarts'
  import {envMonitor, eleSave, waterSave, proSearch} from '../../api/api'
  import ProjectList from "../command/ProjectList";

  export default {
    components: {ProjectList},
    props: ['room'],
    data() {
      return {
        chartLine: null,
        safechart: null,
        value1: false,
        value2: false,
        value3: false,
        value4: false,
        value5: false,
        value6: false,
        value7: false,
        envMonitorData: {timeAxis: [], curveTime: ''},
        eleData: {liveArea: {lastAverVal: 0}, workArea: {lastAverVal: 0}},
        waterData: {
          workArea: {last30Curve: [], timeAxis: [], lastAverCmp: 0, lastAverVal: 0},
          liveArea: {last30Curve: [], timeAxis: [], lastCmp: 0, lastAverVal: 0}
        },
        proId: null,
        proList: [],
      }
    },

    methods: {
      drawPMChart() {
        this.chartLine = echarts.init(document.getElementById('pm'));
        this.chartLine.setOption({
          color: ['#30CF53', '#F6751B'],
          title: {text: 'PM2.5/PM10实时监测', subtext: this.envMonitorData.curveTime},
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            left: 'right',
            data: ['PMC2.5', 'PM10']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.envMonitorData.timeAxis
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'PMC2.5',
              type: 'line',
              data: this.envMonitorData.pm2d5Curve
            },
            {
              name: 'PM10',
              type: 'line',
              data: this.envMonitorData.pm10Curve
            }
          ]
        });
      },
      drawZYChart() {
        this.chartLine = echarts.init(document.getElementById('zy'));
        this.chartLine.setOption({
          color: ['#30CF53', '#F6751B'],
          title: {text: '噪音实时监测', subtext: this.envMonitorData.curveTime},
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            left: 'right',
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.envMonitorData.timeAxis
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'noise',
              type: 'line',
              data: this.envMonitorData.noiseCurve
            }
          ]
        });
      },
      drawElectricChart() {
        this.chartLine = echarts.init(document.getElementById('electric'));
        this.chartLine.setOption({
          color: ['#30CF53', '#F6751B'],
          title: {text: '施工区用电数据'},
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.eleData.workArea.timeAxis
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'PMC2.5',
              type: 'line',
              stack: '总量',
              data: this.eleData.workArea.last30Curve
            }
          ]
        });
      },
      drawWarterChart() {
        this.chartLine = echarts.init(document.getElementById('warter'));
        this.chartLine.setOption({
          color: ['#30CF53', '#F6751B'],
          title: {text: '施工区用水数据'},
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.waterData.workArea.timeAxis
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'PMC2.5',
              type: 'line',
              stack: '总量',
              data: this.waterData.workArea.last30Curve
            }
          ]
        });
      },
      drawLifeChart() {
        this.chartLine = echarts.init(document.getElementById('life'));
        this.chartLine.setOption({
          color: ['#30CF53', '#F6751B'],
          title: {text: '生活区用水数据'},
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.waterData.liveArea.timeAxis
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'PMC2.5',
              type: 'line',
              stack: '总量',
              data: this.waterData.liveArea.last30Curve
            }
          ]
        });
      },
      drawCharts() {
        this.drawZYChart();
        this.drawPMChart();
        this.drawElectricChart();
        this.drawWarterChart();
        this.drawLifeChart();
      },
      option1: function (val) {
        let p = 0;
        if (val) {
          p = 1;
        }
        let params = new FormData();
        params.append('id', 1);
        params.append('jdIndex', 0);
        params.append('jdAction', p);
        option1(params, this.GLOBAL.header).then(result => {
          console.log(result);
        });
      },
      option2: function (val) {
        let p = 0;
        if (val) {
          p = 1;
        }
        let params = new FormData();
        params.append('id', 1);
        params.append('jdIndex', 1);
        params.append('jdAction', p);
        option1(params, this.GLOBAL.header).then(result => {
          console.log(result);
        });
      },
      //雾炮
      option3: function (val) {
        if (val) {
          this.GLOBAL.checkRole(this.GLOBAL.fun.gwp, this.GLOBAL.option.status, this);
        }
      },
      //塔吊喷淋
      option4: function (val) {
        if (val) {
          this.GLOBAL.checkRole(this.GLOBAL.fun.gtdpl, this.GLOBAL.option.status, this);
        }
      },
      //围墙喷淋
      option5: function (val) {
        if (val) {
          this.GLOBAL.checkRole(this.GLOBAL.fun.gwqpl, this.GLOBAL.option.status, this);
        }
      },
      //道路喷淋
      option6: function (val) {
        if (val) {
          this.GLOBAL.checkRole(this.GLOBAL.fun.gdlpl, this.GLOBAL.option.status, this);
        }
      },
      //镝灯
      option7: function (val) {
        if (val) {
          this.GLOBAL.checkRole(this.GLOBAL.fun.gdd, this.GLOBAL.option.status, this);
        }
      },
      //太阳能路灯
      option8: function (val) {
        if (val) {
          this.GLOBAL.checkRole(this.GLOBAL.fun.gtynld, this.GLOBAL.option.status, this);
        }
      },
      proChange: function (proId) {
        this.proId = proId;
        //环境
        envMonitor({num: 10, projectId: this.proId}, this.GLOBAL.header).then(result => {
          if (result.data.res == 'SUCCESS') {
            this.envMonitorData = result.data.data;
          }

        });
        //用电
        eleSave({projectId: this.proId}, this.GLOBAL.header).then(result => {
          if (result.data.res == 'SUCCESS') {
            this.eleData = result.data.data;
          }

        });
        //用水
        waterSave({projectId: this.proId}, this.GLOBAL.header).then(result => {
          if (result.data.res == 'SUCCESS') {
            this.waterData = result.data.data;
          }

        });
      }
    },
    mounted: function () {
    },
    updated: function () {
      this.drawCharts()
    }
  }
</script>

<style scoped>
  .envbox {
    box-shadow: darkgrey 1px 2px 10px 0px;
    padding: 10px;
    margin-top: 20px;
  }

  .tabEnvBox {
    height: 80px;
  }

  .tabEnvBox img {
    width: 30px;
    height: 30px;
    border-radius: 40px;
    padding: 15px;
  }

  .tabEnvBox li {
    width: 170px;
    float: left;
    margin-left: 20px;
    box-shadow: darkgrey 1px 2px 10px 0px;
    list-style: none;
  }

  .mesbox {
    width: 120px;
    height: 100px;
    margin: 0 auto;
    background: #e5e5e5;
    border-radius: 15px;
    border: 1px solid #aeb5bf;
    text-align: center;
  }

  .meslist {
    margin-top: 15px;
  }

  .meslist li {
    list-style: none;
    height: 25px;
    line-height: 25px;
  }

  .mesredcolor {
    color: red;
  }

  .mesgreencolor {
    color: #009d00;
  }

  .tabcheck {
    width: 240px;
    background: #e5e5e5;
    margin: 10px;
  }

  .tabcheck .tabchecktext {
    text-indent: 2em;
  }

  .elebox {
    width: 96%;
    box-shadow: darkgrey 1px 2px 10px 0px;
    margin-top: 20px;
    padding: 10px;
  }

  .eletitle {
    text-align: center;
    margin: 20px;
  }

  .elebox span {
    padding: 10px;
    background: #f8f8f8;
    margin: 5px;
  }

  .elebox table {
    width: 100%;
    background: #b8b8b8;
    overflow-y: scroll;
  }

  .elebox table tr {
    height: 30px;
    text-align: center;
  }

  .trbg {
    background: #DDE5D4
  }

  .tdbg td {
    background: #f8f8f8
  }

  .circle {
    width: 20px;
    height: 20px;
    margin: 0 auto;
    border-radius: 15px;
    background: #000000;
    box-shadow: darkgrey 1px 2px 10px 0px;
  }

  .rcircle {
    width: 20px;
    height: 20px;
    margin: 0 auto;
    border-radius: 15px;
    background: #ff180c;
    box-shadow: darkgrey 1px 2px 10px 0px;
  }

  .recircle {
    width: 20px;
    height: 20px;
    margin: 0 auto;
    border-radius: 15px;
    background: #9f9f9f;
    box-shadow: darkgrey 1px 2px 10px 0px;
  }

  .centerlay {
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .charbox {
    position: relative;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/construction/Construction.vue